export default __webpack_public_path__ + "static/media/black_9_melon_silver_bloodshot_crayon_tech.a086ad66.png";